<template>
  <div class="card">
    <div class="card-title flex space-between baseline">
      <p class="card-title-name">{{ drink.name }}</p>
      <p class="card-title-price">￥{{ drink.price }}</p>
    </div>
    <div class="card-custom">
      <ul>
        <li
          class="card-custom-list flex space-between baseline"
          v-for="custom in drink.custom"
          :key="custom.index"
        >
          <p>{{ custom.customName }}</p>
          <p>＋{{ custom.customPrice }}</p>
        </li>
      </ul>
    </div>
    <div class="card-total flex end">
      <p>￥{{ totalPrice }}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    drink: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    totalPrice() {
      let customTotalPrice = 0;
      if (this.drink.custom.length !== 0) {
        const priceArray = this.drink.custom.map(d => d.customPrice);
        customTotalPrice = priceArray.reduce((prev, current) => prev + current);
      }
      return this.drink.price + customTotalPrice;
    }
  }
};
</script>
<style lang="scss">
.card {
  height: 100%;
  background: #fffffe;
  border-radius: 5px;
  padding: 0.6rem 1rem;
  .card-title {
    .card-title-name {
      font-size: 0.9rem;
      font-weight: bold;
    }
    .card-title-price {
      font-size: 0.7rem;
    }
  }

  .card-custom {
    margin-top: 0.4rem;
    .card-custom-list {
      width: 100%;
      font-size: 0.7rem;
    }
    .card-custom-list + .card-custom-list {
      margin-top: 0.1rem;
    }
  }

  .card-total {
    margin-top: 0.4rem;
    font-size: 0.9rem;
    font-weight: bold;
  }
}
</style>
